import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { Board, SavedLayout } from "@shared/dashboardLayout";

const URL: Record<Board, string> = { ops: "/api/dashboard/layout", fin: "/api/financials/layout" };

/** The viewer's saved grid layout for one dashboard tab (the server returns the default when none is saved). */
export function useBoardLayout(board: Board) {
  const url = URL[board];
  const qc = useQueryClient();
  const query = useQuery<{ layout: SavedLayout }>({ queryKey: [url], staleTime: Infinity });
  const save = useMutation<{ layout: SavedLayout }, Error, SavedLayout>({
    mutationFn: async (layout) => (await apiRequest("PUT", url, { layout })).json(),
    onSuccess: (res) => qc.setQueryData([url], res),
  });
  return { layout: query.data?.layout ?? null, isLoading: query.isLoading, save };
}
